<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_asset')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <row style="margin: 0">
              <div
                style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
              >
                <!-- <b>{{ $t("property.asset.title") }}</b> -->
                <lte-button
                  style="float:right"
                  type="btn
                              btn-primary"
                  right_icon="fa fa-plus"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_asset')"
                  @click="addNew($event)"
                  >{{ $t("property.addnew") }}</lte-button
                >
                <lte-button
                  style="float:right"
                  type="btn
                              btn-info"
                  right_icon="fa fa-print"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('print_asset')"
                  @click="onShowModalPrintAsset($event)"
                  >{{ $t("common.printQrCode") }}</lte-button
                >
                <lte-button
                  style="float:right"
                  type="btn
                              btn-success"
                  right_icon="fa fa-upload"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('import_asset')"
                  @click="importExcel($event)"
                  >{{ $t("apartment.importExcel") }}</lte-button
                >
                <lte-button
                  style="float:right"
                  type="btn
                              btn-info"
                  right_icon="fa fa-download"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('export_asset')"
                  @click="exportAssetExcel($event)"
                  >{{ $t("common.exportFileExcel") }}</lte-button
                >
              </div>
            </row>
            <div class="col-md-12" style="padding: 0">
              <select-option-check
                style=""
                :item="columnsAsset"
                class="dropdown-trigger"
                data-icon="eye"
                @callbackData="saveCustomizeTable"
              ></select-option-check>
            </div>
          </div>

          <div class="box-body">
            <lte-table
              :hdBackground="hdBackground"
              :data="gridAssetDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :actions="
                GET_ACCOUNT_DATA.id == 1 ||
                (has_perm('update_asset') && has_perm('delete_asset'))
                  ? actions
                  : has_perm('update_asset')
                  ? [actions[0]]
                  : has_perm('delete_asset')
                  ? [actions[1]]
                  : []
              "
              @filters="filterData"
              :useFilter="useFilter"
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              @changeBFormSelect="changeBFormSelect"
            ></lte-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            style="padding: 0 15px"
            :item="paginatorItem"
            @onpaginate="onPagination"
          />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
      </row>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-print-asset`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("property.asset.printAssetModalTitle") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="exampleCheck1"
                          v-model="printAssetData.isShowAssetCode"
                        />
                        <label class="form-check-label" for="exampleCheck1">{{
                          $t("propertyMaintenance.assetCode")
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="exampleCheck2"
                          v-model="printAssetData.isShowAssetName"
                        />
                        <label class="form-check-label" for="exampleCheck2">{{
                          $t("property.asset.name")
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="form-check-label" for="exampleCheck1">{{
                        $t("property.asset.numberOfItemPerRow")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="printAssetData.itemPerRow"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onConfirmPrintAsset"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
// import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import Loading from "vue-loading-overlay";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import utils from "@/lib/utils";
import XLSX from "xlsx";

export default {
  name: "Asset",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridAssetDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "common.code", isHidden: true, wrapText: 'nowrap' },
        { text: "property.asset.name", isHidden: true, width: '250px' },
        { text: "property.asset.location", isHidden: true },
        { text: "property.asset.unitsUsed", isHidden: true, wrapText: 'nowrap' },
        { text: "property.asset.type", isHidden: true, wrapText: 'nowrap' },
        { text: "property.asset.maintainance_repeat_option", isHidden: true },
        { text: "property.asset.lastMaintenanceDate", isHidden: true },
        { text: "property.asset.nextMaintainanceDate", isHidden: true },
        { text: "property.asset.asset_status", isHidden: true }
      ],
      columnsAsset: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actions: ["common.modify", "common.delete"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      filterDataOnTable: [],
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      paginatorItem: {
        commit_function: "GET_ASSET_LIST_V2"
      },
      options: {
        format: "YYYY-MM-DD"
      },
      dateOptions: {
        format: "DD-MM-YYYY"
      },
      search: {
        assetCodeAndName: "",
        location: "",
        maintenancePersonnel: "",
        status: "",
        maintainance_start_date: "",
        nextMaintainanceDate: "",
        assetType: "",
        unitsUsed: null,
        supplierId: null,
        manufacturingDate: null
      },
      isLoading: false,
      assetStatusList: [],
      asset_status: 1,
      style: "",
      exportExcelData: {
        headerList: [
          [this.$t("propertyMaintenance.assetCode")],
          [this.$t("property.name")],
          [this.$t("assetType.title")],
          [this.$t("assetType.assetTypeCode")],
          [this.$t("property.quantity")],
          [this.$t("property.asset.maintainance_repeat_option")],
          [this.$t("property.asset.lastMaintenanceDate")],
          [this.$t("property.asset.nextMaintainanceDate")],
          [this.$t("property.asset.unitsUsed")],
          [this.$t("feedback.config.departmentCode")],
          [this.$t("property.asset.asset_status")]
        ],
        dataList: []
      },
      // print qr code
      printAssetData: {
        isShowAssetCode: false,
        isShowAssetName: false,
        itemPerRow: 5
      },
      assetTypeItems: [],
      departmentList: []
    };
  },
  watch: {
    GET_ASSET_LIST_DATA_V2: function() {
      this.gridAssetDataList = [];
      this.GET_ASSET_LIST_DATA_V2.results.forEach((asset, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = asset.code;
        let name = asset.name;
        // let type = asset.type;
        let type_name = asset.type_name;
        let location = asset.location;
        let lastMaintenanceDate = utils.formatSqlDate(asset.last_maintenance_date, null, this.dateOptions.format);
        let asset_status = asset.asset_status;
        this.asset_status = asset_status;
        let id = asset.id;
        let nextMaintainanceDate = utils.formatSqlDate(asset.next_maintainance_date, null, "DD-MM-YYYY");
        let maintainance_repeat_option = asset.maintenance_type === 1
            ? this.$t("property.asset.maintenanceOnce")
            : this.$t("property.asset.cyclical");
        let data = {
          apartment_id: !utils.isNull(asset.apartment) ? asset.apartment.id : 0,
          "common.nonumber": nonumber,
          "common.code": code,
          "property.asset.id": id,
          "property.asset.name": name,
          "property.asset.type": type_name,
          "property.asset.location": location,
          "property.asset.lastMaintenanceDate": lastMaintenanceDate,
          "property.asset.asset_status": asset.asset_status_data.name,
          "property.asset.maintainance_repeat_option": maintainance_repeat_option,
          "property.asset.nextMaintainanceDate": nextMaintainanceDate,
          "property.asset.unitsUsed": asset.department_data.name,
          id: id
        };
        this.gridAssetDataList.push(data);
      });
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsAsset.data_list = this.gridColumns;
      }
    },
    GET_ASSET_TYPE_LIST_DATA: function() {
      let data = this.GET_ASSET_TYPE_LIST_DATA;
      this.assetTypeItems = [
        { value: "", text: this.$t("property.asset.type"), disabled: true },
        { value: null, text: "---" }
      ];
      data.forEach((value, i) => {
        let item = {
          value: value.id,
          text: value.name
        };
        this.assetTypeItems.push(item);
      });
    },
    GET_DEPARTMENT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_NO_PAGE_DATA;
      this.departmentList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          name: value.name
        };
        this.departmentList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ASSET_LIST_DATA_V2",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_ASSET_TYPE_LIST_DATA",
      "GET_DEPARTMENT_LIST_NO_PAGE_DATA"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    importExcel: function() {
      this.$router.push({
        name: "AssetImportExcel",
        params: {
          id: 0
        }
      });
    },
    onSearchAsset: function(page) {
      const data = {
        params: {
          page: page,
          assetCodeAndName: utils.getCleanStringValue(this.search.assetCodeAndName),
          location: utils.getCleanStringValue(this.search.location),
          maintenancePersonnel: utils.getCleanStringValue(this.search.maintenancePersonnel),
          status: utils.getCleanStringValue(this.search.status),
          lastMaintainanceDate: utils.getCleanStringValue(this.search.maintainance_start_date),
          nextMaintainanceDate: utils.getCleanStringValue(this.search.nextMaintainanceDate),
          assetType: utils.getCleanStringValue(this.search.assetType),
          unitsUsed: utils.getCleanStringValue(this.search.unitsUsed),
          supplierId: utils.getCleanStringValue(this.search.supplierId),
          manufacturingDate: utils.getCleanStringValue(this.search.manufacturingDate)
        }
      };
      this.isLoading = true;
      this.GET_ASSET_LIST_V2(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    saveCustomizeTable: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "assetlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNew: function() {
      this.$router.push({
        name: "AssetAdd",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "AssetAdd",
          params: {
            id: recordData.id,
            apartment_id: recordData["apartment_id"],
            apartment_code: recordData["property.asset.of_the_apartment"]
          }
        });
      } else if (actionsType == LTEActionTypeEnum.PRINT) {
        let routeData = this.$router.resolve({
          name: "PropertyPdf",
          params: {
            id: recordData.id
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    filterData: function(from_com_filteredData) {
      this.filterDataOnTable = from_com_filteredData;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_ASSET(this.originalRecordData)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridAssetDataList.length == 1
                ? totalPage >= 2 ? totalPage - 1 : 1
                : currentPage;
            this.onSearchAsset(page);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onPagination: function(data) {
      this.onSearchAsset(data.params.page);
    },
    changeBFormSelect: function(item_id, data_row) {
      let data = {
        asset_status: item_id,
        id: data_row["property.asset.id"]
      };
      this.UPDATE_ASSET_STATUS(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    exportAssetExcel: function() {
      const data = {
        params: {
          assetCodeAndName: utils.getCleanStringValue(this.search.assetCodeAndName),
          location: utils.getCleanStringValue(this.search.location),
          maintenancePersonnel: utils.getCleanStringValue(this.search.maintenancePersonnel),
          status: utils.getCleanStringValue(this.search.status),
          lastMaintainanceDate: utils.getCleanStringValue(this.search.maintainance_start_date),
          nextMaintainanceDate: utils.getCleanStringValue(this.search.nextMaintainanceDate),
          assetType: utils.getCleanStringValue(this.search.assetType),
          unitsUsed: utils.getCleanStringValue(this.search.unitsUsed),
          supplierId: utils.getCleanStringValue(this.search.supplierId),
          manufacturingDate: utils.getCleanStringValue(this.search.manufacturingDate)
        }
      };
      this.isLoading = true;
      this.GET_ASSET_LIST_V2(data).then(
        async function(res) {
          this.isLoading = false;
          let dataList = this.getDataExcelJson(
            this.exportExcelData.headerList,
            res.data
          );
          await this.createAssetExcelFile(dataList);
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
          this.ERROR_TOAST();
        }.bind(this)
      );
    },
    getDataExcelJson: function(headerList, dataList) {
      let resultList = [];
      // let headerListLength = headerList.length
      let assetCodeHeader = headerList[0];
      let assetNameHeader = headerList[1];
      let assetTypeName = headerList[2];
      let assetTypeCode = headerList[3];
      let quantity = headerList[4];
      let maintainanceRepeatOption = headerList[5];
      let lastMaintenanceDate = headerList[6];
      let nextMaintainanceDate = headerList[7];
      let unitsUsedHeader = headerList[8];
      let departmentCodeHeader = headerList[9];
      let assetStatusHeader = headerList[10];
      dataList.forEach(data => {
        let maintainance_repeat_option = data.maintenance_type === 1
            ? this.$t("property.asset.maintenanceOnce") : this.$t("property.asset.cyclical");
        let lastMaintenanceDateData = utils.formatSqlDate(data.last_maintenance_date, null, this.dateOptions.format);
        let asset_status = data.asset_status_data.name;
        let nextMaintainanceDateData = utils.formatSqlDate(data.next_maintainance_date, null, "DD-MM-YYYY");
        let item = {
          [assetCodeHeader]: data.code,
          [assetNameHeader]: data.name,
          [assetTypeName]: data.type_name,
          [assetTypeCode]: data.type_code,
          [quantity]: data.quantity,
          [maintainanceRepeatOption]: maintainance_repeat_option,
          [lastMaintenanceDate]: lastMaintenanceDateData,
          [nextMaintainanceDate]: nextMaintainanceDateData,
          [unitsUsedHeader]: data.department.name,
          [departmentCodeHeader]: data.department.code,
          [assetStatusHeader]: asset_status
        };
        resultList.push(item);
      });
      return resultList;
    },
    createAssetExcelFile: function(jsonData) {
      let data_list = [];

      data_list = jsonData;
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "assetList"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "AssetList.xlsx"); // name of the file is 'book.xlsx'
    },
    getAssetTypeList: function() {
      this.GET_ASSET_TYPE_LIST();
    },
    onCloseModal: function() {
      $(this.$refs[`modal-print-asset`]).modal("hide");
    },
    onShowModal: function() {
      $(this.$refs[`modal-print-asset`]).modal("show");
    },
    onShowModalPrintAsset: function() {
      this.onShowModal();
    },
    onConfirmPrintAsset: function() {
      this.openNewWindowPrintAsset();
    },
    openNewWindowPrintAsset: function() {
      let routeData = this.$router.resolve({
        name: "PrintQRCodeAsset",
        query: {
          isShowAssetCode: this.printAssetData.isShowAssetCode,
          isShowAssetName: this.printAssetData.isShowAssetName,
          itemPerRow: this.printAssetData.itemPerRow,
          //
          assetCodeAndName: utils.getCleanStringValue(this.search.assetCodeAndName),
          location: utils.getCleanStringValue(this.search.location),
          maintenancePersonnel: utils.getCleanStringValue(this.search.maintenancePersonnel),
          status: utils.getCleanStringValue(this.search.status),
          lastMaintainanceDate: utils.getCleanStringValue(this.search.maintainance_start_date),
          nextMaintainanceDate: utils.getCleanStringValue(this.search.nextMaintainanceDate),
          assetType: utils.getCleanStringValue(this.search.assetType)
        }
      });
      window.open(routeData.href, "_blank");
      this.onCloseModal();
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST();
    },
    refreshData: function(data) {
      this.search = {
        assetCodeAndName: utils.getCleanStringValue(data.assetCodeAndName),
        location: utils.getCleanStringValue(data.location),
        maintenancePersonnel: utils.getCleanStringValue(data.maintenancePersonnel),
        status: utils.getCleanStringValue(data.status),
        lastMaintainanceDate: utils.getCleanStringValue(data.maintainance_start_date),
        nextMaintainanceDate: utils.getCleanStringValue(data.nextMaintainanceDate),
        assetType: utils.getCleanStringValue(data.assetType),
        unitsUsed: utils.getCleanStringValue(data.unitsUsed),
        supplierId: utils.getCleanStringValue(data.supplierId),
        manufacturingDate: utils.getCleanStringValue(data.manufacturingDate)
      }
      this.onSearchAsset(1)
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_ASSET_LIST_V2",
      "DELETE_ASSET",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_ASSET_STATUS_LIST",
      "UPDATE_ASSET_STATUS",
      "GET_ASSET_TYPE_LIST",
      "GET_DEPARTMENT_LIST"
    ])
  },
  async mounted() {
    this.isLoading = true;
    const data = {
      params: {
        page: 1
      }
    };
    await this.GET_ASSET_STATUS_LIST().then(
      function(res) {
        let getStatusAssetDataList = res.data;
        let getStatusList = [
          { value: "", text: this.$t("property.asset.status"), disabled: true },
          { value: null, text: "---" }
        ];

        getStatusAssetDataList.forEach(item => {
          const obj = {
            value: item.id,
            text: item.name
          };
          getStatusList.push(obj);
        });
        this.assetStatusList = getStatusList;
      }.bind(this)
    );
    await this.getAssetTypeList();

    this.GET_ASSET_LIST_V2(data);
    this.columnsAsset.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "assetlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);

    this.getDepartmentList();
    this.isLoading = false;
  },

  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    // "date-picker": datePicker,
    loading: Loading,
    "select-option-check": SelectOptionCheck
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Property/AssetListV2.vue